"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.resultMessages = exports.Result = void 0;
const schema_1 = require("../../../../schema");
var Result;
(function (Result) {
    Result["ABNORMAL"] = "ABNORMAL";
    Result["NORMAL"] = "NORMAL";
})(Result || (exports.Result = Result = {}));
exports.resultMessages = {
    [Result.ABNORMAL]: {
        id: "ktx.transplantationScreening.tumourResearch.colonoscopy.result.ABNORMAL",
        defaultMessage: "Van eltérés"
    },
    [Result.NORMAL]: {
        id: "ktx.transplantationScreening.tumourResearch.colonoscopy.result.NORMAL",
        defaultMessage: "Nincs eltérés"
    }
};
const result = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Result.ABNORMAL),
    schema_1.Schema.singleChoiceItem(Result.NORMAL)
]);
const comment = schema_1.Schema.string().optional().maxLength(10000);
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ result, comment })
    .interpretation({ vocab: "ktx", code: "colonoscopy" })
    .tag({ vocab: "snomed", code: "73761001" })
    .tag({ vocab: "loinc", code: "18746-8" })
    .tag({ vocab: "ktx", code: "tumour_research" });
